import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function LinktGOIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="LinktGO" fill="none">
          <g clipPath="url(#a)">
              <path
                  fillRule="evenodd"
                  d="M9.768.25h4.464c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v12.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H9.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2V5.768c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47A3.75 3.75 0 0 1 6.298.658c.444-.226.924-.32 1.47-.365C8.3.25 8.956.25 9.769.25ZM7.89 1.788c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v12.4c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h4.4c.853 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909V5.8c0-.852 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.983-.984c-.198-.1-.459-.17-.913-.207-.462-.037-1.057-.038-1.909-.038H9.8c-.852 0-1.447 0-1.91.038ZM12 19a1 1 0 0 1 1 1v.042a1 1 0 1 1-2 0V20a1 1 0 0 1 1-1ZM11 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
                  clipRule="evenodd"
              />
          </g>
      </SvgIcon>
  );
}
